<template>
  <div class="bg_box">
    <div class="box">
      <div style="height: 20px"></div>
      <div class="aside_box"  @click="goSearch">
        <el-input placeholder="请输入内容"   class="input-with-select">
          <el-select v-model="selects" slot="prepend" placeholder="请选择">
            <el-option label="搜索职位" value="1"></el-option>
            <el-option label="搜索企业" value="2"></el-option>
            <el-option label="搜索社团" value="3"></el-option>
          </el-select>

          <el-button slot="append" >搜索</el-button>
        </el-input>
        <div class="hotbox">
          <div class="leftbox">热门搜索：</div>
          <div class="rightbox"  v-for="(item, index) in hotlist" :key="index">
            <div style="cursor: pointer;">{{ item }}</div>
          </div>
        </div>
        <div class="linebox"></div>

        <div class="classify">
          <div>
            <el-select v-model="educationFilter" placeholder="学历要求"  style="margin-right:40px">
              <el-option v-for="item in option1"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="jobTypeFilter" placeholder="工作性质"
                       style="margin-right:40px"
                       >
              <el-option v-for="item in option2"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="experienceFilter" placeholder="工作经验"  style="margin-right:40px">
              <el-option v-for="item in option3"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-cascader :options="options"
                         placeholder="职位类别"
                         clearable></el-cascader>
          </div>
          <div style="cursor: pointer;">清空搜索条件</div>
        </div>
      </div>

      <div class="content_box">
        <div class="content_child_left">
          <div class="content_bg1" @click="goSearch">
            <span>岗位大厅</span>
          </div>
          <div class="content_bg2"   @click="goSearch">
            <span>大学生兼职</span>
          </div>
          <div class="content_bg3">
            <span>创业中心</span>
          </div>
          <div class="content_bg4">
            <span>众包专区</span>
          </div>
        </div>

        <div class="content_child_right">
          <img :src="banner[0]?banner[0].image:''"  @click="goSearch" />
        </div>
      </div>



      <div v-for="(recommend, index) in recomlist"
           :key="index">
        <div class="list_box">
          <div class="list_box_child"  @click="more(recommend.recommend_id, recommend.name)">
            <div>{{ recommend.name }}</div>
            <div class="gen">更多&gt;</div>
          </div>

          <div class="list_box_s">
            <el-select disabled
                       v-model="filterWorkPlace"
                       placeholder="工作地点">
              <el-option v-for="item in option1"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-select disabled
                       v-model="filterEducation"
                       placeholder="学历要求"
                       style="margin: 0 40px">
                <el-option v-for="item in option2"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                </el-option>
            </el-select>
            <el-select disabled
                       v-model="filterSex"
                       placeholder="性别">
              <el-option v-for="item in option3"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </div>

          <el-carousel :interval="5000"  arrow="always" indicator-position="none" class="carousel">
            <el-carousel-item v-if="recommend.data.data1.length != 0">
              <div class="list_box_childs">
                <div class="list_box_childs_s"
                     v-for="(item, index) in recommend.data.data1"
                     :key="index">
                  <div style="width:95%;margin:10px;auto;"
                       @click="jobdetail(item.job_id)">
                    <div class="list_flag"
                         style="padding-bottom: 10px">
                      <div>
                        {{ item.alias_name }}&emsp;<span style="color: #999999">{{ item.created_at }}</span>发布
                      </div>
                      <div>浏览量：{{item.views}}</div>
                      <div>
                        距离：<span style="color: #7893db">{{item.km}}</span>
                      </div>
                    </div>
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div class="list_flag_child">
                        <div style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                              ">
                          <div class="list_flag_text">
                            {{ item.title }}
                          </div>
                          <div style="color: #7893db">[兼职]</div>
                          <img style="width: 20px; height: 20px"
                               src="/img/火爆.png" />
                          <div style="font-weight: bold; color: red">
                            {{ item.wages_min }}-{{ item.wages_max }}{{ item.unit_str || item.unit }}
                          </div>
                        </div>
                        <div>
                          <span style="padding-right: 20px">工作时间：{{ item.work_time }}</span>
                          <span v-show="item.sex == 0">男女不限</span>
                          <span v-show="item.sex == 1">男</span>
                          <span v-show="item.sex == 2">女</span>
                          <span style="padding-left: 20px">{{item.education_str }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="list_flag_bottom">
                      <div>截止日期：剩余{{ item.count_down }}天</div>
                      <div>
                        空余岗位：（<span style="color: red">{{item.surplus_number}}</span>）个
                      </div>
                    </div>
                    <div class="list_flag_bottoms">
                      <div class="list_flag_bottom_child">五险一金</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item v-if="recommend.data.data2.length != 0">
              <div class="list_box_childs">
                <div class="list_box_childs_s" v-for="(item, index) in recommend.data.data2" :key="index">
                  <div style="width:95%;margin:10px;auto;"
                       @click="jobdetail(item.job_id)">
                    <div class="list_flag"
                         style="padding-bottom: 10px">
                      <div>
                        {{ item.alias_name }}&emsp;<span style="color: #999999">{{ item.created_at }}</span>发布
                      </div>
                      <div>浏览量：{{item.views}}</div>
                      <div>
                        距离：<span style="color: #7893db">{{item.km}}</span>
                      </div>
                    </div>
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div class="list_flag_child">
                        <div style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                              ">
                          <div class="list_flag_text">
                            {{ item.title }}
                          </div>
                          <div style="color: #7893db">[兼职]</div>
                          <img style="width: 20px; height: 20px"
                               src="@/assets/img/火爆.png" />
                          <div style="font-weight: bold; color: red">
                            {{ item.wages_min }}-{{ item.wages_max
                                }}{{ item.unit }}
                          </div>
                        </div>
                        <div>
                          <span style="padding-right: 20px">工作时间：{{ item.work_time }}</span>
                          <span v-show="item.sex == 0">男女不限</span>
                          <span v-show="item.sex == 1">男</span>
                          <span v-show="item.sex == 2">女</span>
                          <span style="padding-left: 20px">{{
                                item.education_str
                              }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="list_flag_bottom">
                      <div>截止日期：剩余{{ item.count_down }}天</div>
                      <div>
                        空余岗位：（<span style="color: red">{{
                              item.surplus_number
                            }}</span>）个
                      </div>
                    </div>
                    <div class="list_flag_bottoms">
                      <div class="list_flag_bottom_child">五险一金</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item v-if="recommend.data.data3.length != 0">
              <div class="list_box_childs">
                <div class="list_box_childs_s"
                     v-for="(item, index) in recommend.data.data3"
                     :key="index">
                  <div style="width:95%;margin:10px;auto;"
                       @click="jobdetail(item.job_id)">
                    <div class="list_flag"
                         style="padding-bottom: 10px">
                      <div>
                        {{ item.alias_name }}&emsp;<span style="color: #999999">{{ item.created_at }}</span>发布
                      </div>
                      <div>浏览量：{{item.views}}</div>
                      <div>
                        距离：<span style="color: #7893db">{{item.km}}</span>
                      </div>
                    </div>
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div class="list_flag_child">
                        <div style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                              ">
                          <div class="list_flag_text">
                            {{ item.title }}
                          </div>
                          <div style="color: #7893db">[兼职]</div>
                          <img style="width: 20px; height: 20px"
                               src="/img/火爆.png" />
                          <div style="font-weight: bold; color: red">
                            {{ item.wages_min }}-{{ item.wages_max
                                }}{{ item.unit }}
                          </div>
                        </div>
                        <div>
                          <span style="padding-right: 20px">工作时间：{{ item.work_time }}</span>
                          <span v-show="item.sex == 0">男女不限</span>
                          <span v-show="item.sex == 1">男</span>
                          <span v-show="item.sex == 2">女</span>
                          <span style="padding-left: 20px">{{
                                item.education_str
                              }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="list_flag_bottom">
                      <div>截止日期：剩余{{ item.count_down }}天</div>
                      <div>
                        空余岗位：（<span style="color: red">{{
                              item.surplus_number
                            }}</span>）个
                      </div>
                    </div>
                    <div class="list_flag_bottoms">
                      <div class="list_flag_bottom_child">五险一金</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item v-if="recommend.data.data4.length != 0">
              <div class="list_box_childs">
                <div class="list_box_childs_s"
                     v-for="(item, index) in recommend.data.data4"
                     :key="index">
                  <div style="width:95%;margin:10px;auto;"
                       @click="jobdetail(item.job_id)">
                    <div class="list_flag"
                         style="padding-bottom: 10px">
                      <div>
                        {{ item.alias_name }}&emsp;<span style="color: #999999">{{ item.created_at }}</span>发布
                      </div>
                      <div>浏览量：{{item.views}}</div>
                      <div>
                        距离：<span style="color: #7893db">{{item.km}}</span>
                      </div>
                    </div>
                    <div class="list_flag">
                      <div style="width: 10%">
                        <img :src="item.logo" />
                      </div>
                      <div class="list_flag_child">
                        <div style="
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                              ">
                          <div class="list_flag_text">
                            {{ item.title }}
                          </div>
                          <div style="color: #7893db">[兼职]</div>
                          <img style="width: 20px; height: 20px"
                               src="/img/火爆.png" />
                          <div style="font-weight: bold; color: red">
                            {{ item.wages_min }}-{{ item.wages_max
                                }}{{ item.unit }}
                          </div>
                        </div>
                        <div>
                          <span style="padding-right: 20px">工作时间：{{ item.work_time }}</span>
                          <span v-show="item.sex == 0">男女不限</span>
                          <span v-show="item.sex == 1">男</span>
                          <span v-show="item.sex == 2">女</span>
                          <span style="padding-left: 20px">{{
                                item.education_str
                              }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="list_flag_bottom">
                      <div>截止日期：剩余{{ item.count_down }}天</div>
                      <div>
                        空余岗位：（<span style="color: red">{{
                              item.surplus_number
                            }}</span>）个
                      </div>
                    </div>
                    <div class="list_flag_bottoms">
                      <div class="list_flag_bottom_child">五险一金</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="bannerbox">
          <img src="@/assets/image/banner.png" />
        </div>
      </div>
      
    </div>
  </div>
</template>
  
  <script>
import { indexlist } from "@/api/personal/job/index";
import { bannerimage } from "@/api/director/talent/index";
export default {
  data () {
    return {
     
      selects: "",
      educationFilter: "",
      jobTypeFilter: "",
      experienceFilter: "",
      filterWorkPlace: "",
      filterEducation: "",
      filterSex: "",
      option1: [
        {
          value: "0",
          label: "不限",
        },
        {
          value: "1",
          label: "初中及以下",
        },
        {
          value: "2",
          label: "高中及以上",
        },
        {
          value: "3",
          label: "大专及以上",
        },
        {
          value: "4",
          label: "本科及以上",
        },
        {
          value: "5",
          label: "研究生及以上",
        },
     
      ],
      option2: [
        {
          value: "1",
          label: "不限",
        },
        {
          value: "2",
          label: "兼职",
        },
        {
          value: "3",
          label: "全职",
        },
      ],
      option3: [
        {
          value: "1",
          label: "不限",
        },
        {
          value: "2",
          label: "有经验",
        },
        {
          value: "3",
          label: "无经验",
        },
      ],
      options: [

      ],
      hotlist: [
        "家政",
        "出纳",
        "人才资源经理",
        "机械工程师",
        "审计",
        "清洁工",
        "普工",
        "叉车司机",
        "塔吊司机",
      ],
      recomlist: [],
      banner: []
    };
  },
  created () {
    this.getlist();
  },
  mounted () {
    this.getLocation()
    this.getbanner()
  },
  methods: {
    getbanner () {
      bannerimage({ identity: 1 }).then(res => {
        this.banner = res.data
      })
    },
    goSearch () {
      this.$router.push({ name: "job-search" });
    },
    more (id, name) {
      this.$router.push({
        name: "job-more",
        query: { id: id, name: name },
      });
    },

    jobdetail (id) {
      this.$router.push({ name: "job-detail", query: { id: id } });
    },
   
    //定位当前位置
    getLocation () {
      if (typeof window.qq === 'undefined' || !window.qq.maps) {
        return;
      }
      var geolocation = new window.qq.maps.Geolocation(
        "EYFBZ-4BKW6-HYVS7-EEFUP-QRAH5-7LBBX",
        "referer-jianzhibei"
      );
      geolocation.getLocation(this.showPosition, this.errorPosition);
    },
    showPosition (position) {
      let data = {
        lat: position.lat,
        lng: position.lng
      }
      indexlist(data).then((res) => {
        this.recomlist = res.data;
      });
    },
    errorPosition () {
      console.log("定位失败");
      //继续定位
      this.getLocation();
    },

    //搜索
    getlist () {
      indexlist().then((res) => {
        this.recomlist = (res && res.data) ? res.data : [];
      }).catch(() => {
        this.recomlist = [];
      });
    },
  },
};
  </script>
  
<style lang='scss' scoped>
::v-deep .el-select .el-input {
  width: 100px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-select .el-input__inner {
  border: none;
}
.el-input.is-disabled .el-input__inner {
  background-color: #fff;
}

::v-deep .el-carousel__container{
  height: 320px;
}

.page {
  .bg_box {
    background-color: #eeeeee;
  }
  // height: 100vh;
  .box {
    width: 1200px;
    margin: auto;
    .bannerbox {
      img {
        width: 100%;
      }
    }
    .list_box {
      padding: 25px 0;
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      margin: 20px 0;
      .list_box_s {
        width: 95%;
        padding: 5px 5px;
        margin: auto;
        display: flex;
        align-items: center;
        border-radius: 10px;
        margin-bottom: 20px;
        border: 1px solid #dadada;
      }
      .list_box_child {
        width: 95%;
        padding-bottom: 20px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .gen {
          color: #c8c8c8;
          cursor: pointer;
          font-size: 14px;
        }
      }

      .carousel{
        width: 95%;
        margin:auto
      }


      .list_box_childs {
    
        height: 100%;
        margin: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .list_box_childs_s:hover {
          background-color: #faf7f8;
        }
        .list_box_childs_s {
          font-size: 12px;
          width: 48.5%;
          border: 1px solid #c8c8c8;
          border-radius: 8px;
          height: 150px;
          .sty {
            padding: 0 30px;
          }
          .list_flag_bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: 5px;
          }
          .list_flag_bottoms {
            display: flex;
            align-items: center;
            padding-top: 5px;
            .list_flag_bottom_child {
              padding: 2px 5px;
              border: 1px solid #999999;
              margin-right: 10px;
              border-radius: 5px;
            }
          }
          .list_flag {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .list_flag_child {
              .list_flag_text {
                font-weight: bold;
                font-size: 16px;
                width: 150px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              width: 88%;
              height: 50px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: left;
            }
          }
          img {
            width: 50px;
            height: 50px;
            border-radius: 20%;
          }
        }
      }
    }
    .content_box {
      height: 328px;
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      // margin-bottom: 30px;
      padding: 10px;
      display: flex;
      .content_child_left {
        color: white;
        margin-right: 5px;
        width: 39%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .content_bg1 {
          background: url(~@/assets/img/gangweidating.png);
          background-repeat: no-repeat;
          background-size: 100%;
          width: 49%;
          height: 160px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .content_bg2 {
          background: url(~@/assets/img/daxueshengjianzhi.png);
          background-repeat: no-repeat;
          background-size: 100%;
          width: 49%;
          height: 160px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .content_bg3 {
          background: url(~@/assets/img/chuangyezhongxin.png);
          background-repeat: no-repeat;
          background-size: 100%;
          width: 49%;
          height: 160px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 8px;
        }
        .content_bg4 {
          background: url("~@/assets/img/zhongbaozhuanqu.png");
          background-repeat: no-repeat;
          background-size: 100%;
          width: 49%;
          height: 160px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 8px;
        }
      }
      .content_child_right {
        width: 60%;
        height: 100%;
        opacity: 1;
        border-radius: 8px;
        // background-image: url(../../assets/1.jpg);
        // background-size: 100% 100%;
        // background-repeat: no-repeat;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .aside_box {
      opacity: 1;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      // margin-top: 20px;
      margin-bottom: 30px;
      padding: 20px;
      .classify {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .linebox {
        height: 2px;
        background-color: #dadada;
        margin-bottom: 20px;
      }
      .hotbox {
        margin: 20px 0;
        display: flex;
        align-items: center;
        .leftbox {
          padding-right: 20px;
        }
        .rightbox {
          color: #4c71db;
          display: flex;
          align-items: center;
          div {
            padding: 0 20px;
          }
        }
      }
    }
  }
}
</style>
  